import { ColDef } from 'ag-grid-community'
import { WbsItemAdditionalPropertyEntity } from '../../../../../../domain/entity/WbsItemAdditionalPropertyEntity'
import { Option } from '..'
import MultiLineTextCell from '../../../../commons/AgGrid/components/cell/custom/multiLineText'
import {
  ClientSideTextFilter,
  ServerSideTextFilter,
  TextFilter,
} from '../../../components/filter'
import { ServerSideTextFloatingFilter } from '../../../components/floatingFilter'
import { filter } from '../../../../../pages/ProjectPlanNew/projectPlanNew'
import { ColumnType } from '../../../../commons/AgGrid'
import {
  FunctionProperty,
  PropertyType,
} from '../../../../../../lib/commons/appFunction'

export const multiLineTextColumnDef = <RowData>(
  column: ColDef,
  wbsItemAdditionalProperty: WbsItemAdditionalPropertyEntity,
  option: Option<RowData>
): void => {
  column.type = [ColumnType.multiLineText]
  column.cellEditor = MultiLineTextCell.cellEditor
  column.cellRenderer = MultiLineTextCell.cellRenderer
  setFilterParams(column, wbsItemAdditionalProperty, option)
  column.cellRendererParams = {
    ...column.cellRendererParams,
    uiMeta: {
      propertyType: PropertyType.MultiLineText,
      maxLength: 10000,
    } as Partial<FunctionProperty>,
  }
}
const setFilterParams = <RowData>(
  column: ColDef,
  wbsItemAdditionalProperty: WbsItemAdditionalPropertyEntity,
  option: Option<RowData>
) => {
  switch (option.columnFilterType) {
    case 'CLIENT_SIDE':
      column.filter = ClientSideTextFilter
      column.floatingFilter = !option.disableFloatingFilter
      break
    case 'SERVER_SIDE':
      column.filter = ServerSideTextFilter
      column.floatingFilter = !option.disableFloatingFilter
      column.floatingFilterComponent = ServerSideTextFloatingFilter
      column.filterParams = {
        fetch: (v: TextFilter) => {
          return filter({
            projectUuid: wbsItemAdditionalProperty.projectUuid,
            additionalPropertyValues: [
              {
                wbsItemAdditionalPropertyUuid: wbsItemAdditionalProperty.uuid,
                propertyType: wbsItemAdditionalProperty.propertyType,
                operator: v.operator,
                value: v.value,
              },
            ],
          })
        },
      }
      break
    default:
      break
  }
}
